<template>
  <div class="detailed_report_form" :style="screenHeight">
    <div class="fixed_search" style="height: 100px;">
      <div class="fixed_search_input">
        <Select v-model="formType" placeholder="请选择报表类型" title="报表类型">
          <Option v-for="(option, index) in formTypeList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
      </div>
      <div class="date_input fixed_search_input">
        <el-date-picker title="日期" v-model="starEndTime" :clearable="false" unlink-panels type="datetimerange" start-placeholder="开始时间" end-placeholder="结束时间" align="left" :default-time="['00:00:00', '23:59:59']"  :editable="false" :picker-options="pickerOptions"  format="yyyy-MM-dd HH:mm:ss"  value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </div>
      <div class="fixed_search_input">
        <Input v-model="agentNumber" placeholder="请输入员工工号" title="员工工号"/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="employeeName" placeholder="请输入员工姓名" title="员工姓名"/>
      </div>
      <div class="fixed_search_input">
        <Input v-model="deptName" placeholder="请输入部门名称" title="部门名称"/>
      </div>
      <div class="fixed_search_input compare_select">
        <Select v-model="compareNewNum"  clearable title="创建工单量">
          <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Input v-model="newNum" placeholder="创建工单量" title="创建工单量"/>
      </div>
      <div class="fixed_search_input compare_select">
        <Select v-model="compareAssignNum"  clearable title="分配工单量">
          <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Input v-model="assignNum" placeholder="分配工单量" title="分配工单量"/>
      </div>
      <div class="fixed_search_input compare_select">
        <Select v-model="compareDealNum"  clearable title="抢接工单量">
          <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Input v-model="dealNum" placeholder="抢接工单量" title="抢接工单量"/>
      </div>
      <div class="fixed_search_input compare_select">
        <Select v-model="compareDealDoneNum"  clearable title="已完成工单量">
          <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Input v-model="dealDoneNum" placeholder="已完成工单量" title="已完成工单量"/>
      </div>
      <div class="fixed_search_input compare_select">
        <Select v-model="compareDealCloseNum"  clearable title="关闭工单量">
          <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Input v-model="dealCloseNum" placeholder="关闭工单量" title="关闭工单量"/>
      </div>
      <div class="fixed_search_input compare_select">
        <Select v-model="compareResponseTimeSecond"  clearable title="平均响应时长">
          <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Input v-model="responseTimeSecond" placeholder="平均响应时长(秒)" title="平均响应时长(秒)"/>
      </div>
      <div class="fixed_search_input compare_select">
        <Select v-model="compareProcessTimeSecond"  clearable title="平均处理时长">
          <Option v-for="(option, index) in compareList" :value="option.id" :key="index">{{option.name}}</Option>
        </Select>
        <Input v-model="processTimeSecond" placeholder="平均处理时长(秒)" title="平均处理时长(秒)"/>
      </div>
      <div class="fixed_operation_btn">
        <Button type="primary" @click="initSearch">查询</Button>
        <Button type="primary" class="operation_btn reset_btn" @click="reset">重置</Button>
        <Button type="info" class="operation_btn" @click="exportExcel('8_7-2-1','统计报表=>工单统计=>客服工作量统计')" v-if="roleList['8_7-2-1']">导出</Button>
      </div>
      <div class="fixed_operation_btn" style="margin-top:-3px">
        <Tooltip class="tips_font" placement="bottom">
          <div slot="content">
            <p>日期：统计的单位时间</p>
            <p>员工工号：单位时间内员工的工号</p>
            <p>员工姓名：单位时间内员工的姓名</p>
            <p>部门名称：单位时间内员工的部门名称</p>
            <p>创建工单量：单位时间内该员工创建的工单量</p>
            <p>分配工单量：单位时间内该员工分配的工单量</p>
            <p>抢接工单量：单位时间内该员工抢单/接单的工单量</p>
            <p>已完成工单量：单位时间内该员工完成的工单量</p>
            <p>关闭工单量：单位时间内该员工关闭的工单量</p>
            <p>平均响应时长：单位时间内员工接单/抢单时的响应时长总和÷单位时间内员工接单/抢单时的次数</p>
            <p>平均处理时长：单位时间内员工接单/抢单后变更工单状态的处理时长总和÷单位时间内员工接单/抢单后变更工单状态的次数</p>
          </div>
          <img src="../../../assets/image/homeAsk.png"/>
        </Tooltip>
      </div>
    </div>
    <div class="fixed_table">
      <Spin size="large" fix v-if="spinShow"><Icon type="ios-loading" size=18 class="demo-spin-icon-load"></Icon><div>正在加载中...</div></Spin>
      <el-table :data="contentList" style="width: 100%" :height="tableHeight" class="element_table" :class="{'tableClass':tableClass}" stripe ref="selection" @selection-change="getSelectedId">
        <el-table-column v-for="(item,index) in fieldList" align="center" :show-overflow-tooltip='true' :type="item.type" :key="index" :fixed="item.fixed" :prop="item.key" :label="item.title" :width="item.width">
          <template slot="header" slot-scope="scope">
            <el-tooltip  placement="top">
              <span style="overflow:hidden;text-overflow:ellipsis;white-space: nowrap;">{{item.title}}</span>
              <div slot="content" >
                <span>{{item.title}}</span>
              </div>
            </el-tooltip>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="page_style">
      <Page :total="total" size="small" :page-size='pageSize' :current='currentPage' :page-size-opts="pageSizeList" show-total show-sizer  @on-change="changeCurrent" @on-page-size-change="changeSize"/>
      <div style="padding-top: 2px;">跳至</div><Input class="show-elevator" v-model="speedChangePage" @on-blur="handleCurrentPage"/><div style="padding-top: 2px;">页</div>
    </div>
  </div>
</template>

<script>
  import {publicFunClass} from '@/components/js/PublicFunClass.js'
  import {customerPublicBtn} from '@/components/js/CustomerPublicBtn.js'
    export default {
        name: "AgentWorkloadStatistics",
      mixins:[publicFunClass,customerPublicBtn],
      props:{
        pageCode:String
      },
      data(){
        return {
          roleList:JSON.parse(localStorage.getItem("roleList")),
          screenHeight:{height:''},
          tableHeight:600,
          total:0,
          pageSizeList:[10,20,30,40,50,100,200],
          currentPage:1,
          pageSize:20,
          speedChangePage: 1,
          spinShow:false,
          popSign:'',
          fieldList: [
            {width:180,fixed: true,key:'date','title':'日期'},{width: 130, fixed: true,key:'agentNumber','title':'员工工号'},
            {width: 150, fixed: true,key:'employeeName','title':'员工姓名'},{width: 150,key:'deptName','title':'部门名称'},{width: 140,key:'newNum','title':'创建工单量'},{width:140,key:'assignNum','title':'分配工单量'},
            {width: 140,key:'dealNum','title':'抢接工单量'},{width: 140,key:'dealDoneNum','title':'已完成工单量'}, {width: 140,key:'dealCloseNum','title':'关闭工单量'},
            {width: 170,key:'responseTimeHour','title':'平均响应时长'},{width: 170,key:'processTimeHour','title':'平均处理时长'},
          ],
          contentList: [],
          compareList:[{'id':'>','name':'大于'},{'id':'=','name':'等于'},{'id':'<','name':'小于'},{'id':'>=','name':'大于等于'},{'id':'<=','name':'小于等于'}],
          starEndTime:[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')],
          journalType:"null",
          menuId:"null",
          configInfo: JSON.parse(localStorage.getItem("configInfo")),
          agentNumber:'',
          employeeName:'',
          formTypeList:[{'id':'1','name':'日报'},{'id':'2','name':'周报'},{'id':'3','name':'月报'}],
          formType:'1',
          tableClass: true,
          showPageCount:0,
          newNum:'',
          assignNum:'',
          dealNum:'',
          dealCloseNum:'',
          dealDoneNum:'',
          deptName:'',
          responseTimeSecond:'',
          processTimeSecond:'',
          compareNewNum:'',
          compareAssignNum:'',
          compareDealNum:'',
          compareDealCloseNum:'',
          compareDealDoneNum:'',
          compareResponseTimeSecond:'',
          compareProcessTimeSecond:'',
          oldParam:{},
        }
      },
      methods:{
        initSearch:function () {
          this.spinShow=true;
          this.$emit("closeVn",true);
          let that=this;
          let param={
            formType:this.formType,
            newNum:this.newNum,
            assignNum:this.assignNum,
            dealNum:this.dealNum,
            dealCloseNum:this.dealCloseNum,
            date:this.starEndTime.length==0?"":this.starEndTime.toString(),
            dealDoneNum:this.dealDoneNum,
            employeeName:this.employeeName,
            agentNumber:this.agentNumber,
            deptName:this.deptName,
            responseTimeSecond:this.responseTimeSecond,
            processTimeSecond:this.processTimeSecond,
            compareNewNum:this.compareNewNum,
            compareAssignNum:this.compareAssignNum,
            compareDealNum:this.compareDealNum,
            compareDealCloseNum:this.compareDealCloseNum,
            compareDealDoneNum:this.compareDealDoneNum,
            compareResponseTimeSecond:this.compareResponseTimeSecond,
            compareProcessTimeSecond:this.compareProcessTimeSecond,
            journalType:"null",
            menuId:"null",
            pageNum:this.currentPage,
            pageSize:this.pageSize,
            currentPage:this.currentPage,
          };
          this.oldParam = param;
          this.$http.post("orderForm/toCustomerServiceStatisticsIndex.json",param) .then(function (res) {
            let result=res.data;
            that.spinShow=false;
            if(result.flag!="666"){
              that.$Modal.info({
                title:'提示',
                content:res.data.msg
              });
              return false;
            }
            that.contentList=res.data.obj.list.content;
            that.total=res.data.obj.list.totalSize;
            let timeShowStyle=that.configInfo.timeShowStyle;
            if(timeShowStyle=='1'){
              for(let i=0;i< that.contentList.length;i++){
                that.contentList[i].responseTimeHour=that.contentList[i].responseTimeSecond+" 秒";
                that.contentList[i].processTimeHour=that.contentList[i].processTimeSecond+" 秒";
              }
            }
          })
        },
        reset:function(){
          this.starEndTime=[this.getDate(new Date(),'00:00:00'),this.getDate(new Date(),'23:59:59')];
          this.agentNumber = "";
          this.employeeName = "";
          this.deptName = "";
          this.formType = "1";
          this.newNum = "";
          this.assignNum = "";
          this.dealNum = "";
          this.dealCloseNum = "";
          this.dealDoneNum = "";
          this.deptName = "";
          this.responseTimeSecond = "";
          this.processTimeSecond = "";
          this.compareNewNum = "";
          this.compareAssignNum = "";
          this.compareDealNum = "";
          this.compareDealCloseNum = "";
          this.compareDealDoneNum = "";
          this.compareResponseTimeSecond = "";
          this.compareProcessTimeSecond = "";
        },
        //导出
        exportExcel:function (menuId,journalType) {
          if(this.contentList.length==0){
            this.$Modal.info({
              title:'提示',
              content:"当前无可导出的数据"
            });
            return false;
          }
          if(!this.oldParam){
            this.$Modal.info({
              title:'提示',
              content:"请点击查询后再导出"
            });
            return false;
          }
          this.journalType=journalType;
          this.menuId=menuId;
          //统计报表没有按选中结果导出
          let param = JSON.parse(JSON.stringify(this.oldParam));
          param.type = '1';
          param.journalType = this.journalType+"按搜索结果导出";
          param.menuId = this.menuId;
          this.$delete(param,'pageNum');
          this.$delete(param,'pageSize');
          this.$delete(param,'currentPage');
          this.$Loading.start();
          this.operateExcelExport(param,"orderForm/exportCustomerServiceStatistics.json");
        },
      },
      created(){
        this.oldParam = {};
        this.screenHeight.height=this.mountHeight(91);
        let clientHeight=document.documentElement.clientHeight;
        this.tableHeight=clientHeight-232;
      },
      destroyed(){
        this.$emit("closeVn",true);
        clearInterval(this.scrollInterval);
      },
      watch:{
        pageCode:function () {
          if(this.pageCode=='8_7-2' && this.showPageCount==0){
            this.$emit("openVn", true);
            this.showPageCount++;
            this.handleScroll();
          }
        }
      }
    }
</script>

<style>
  .el-table th.gutter{
    display: table-cell!important;
  }
  .el-table .el-table__body-wrapper::-webkit-scrollbar{
    width:auto;
    width:15px;
    height:8px;
  }
</style>



// WEBPACK FOOTER //
// src/components/statisticsReportForm/workOrderReportForm/AgentWorkloadStatistics.vue